
   

  
 jQuery(document).ready(function(){
  
  


    //-- its a product page

    var variant = null;
    var variantJson = null;

      try{
        variant =  jQuery('form[action="/cart/add"]').attr("id").split('-')[1];
        variantJson = JSON.parse($("#VariantsJson-" + variant).text());
      }
      catch(e){

        variant = null;
      }

      if (variant != null){

       jQuery(variantJson).each(function(index,val){

        if (!jQuery(val)[0].available){

        var div =  jQuery('#ProductSelect-' + variant + '-option-1 div:nth-child('+(index+1)+')');

         jQuery(div).find('label').addClass('disabled');

        }

      });
    }
  });

jQuery(document).ready(function(){    
    jQuery('.show-more').on('click', function(e) {           
        jQuery(this).parent().addClass('active');            
    });    
});



  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
        e.preventDefault();

        document.querySelector(this.getAttribute('href')).scrollIntoView({
            behavior: 'smooth'
        });
    });
});


jQuery(document).ready(function(){  
setTimeout(function(){
$('.shopify-payment-button__button').text('תשלום');
},1000);    
});
 

/* for mobile view */
jQuery(document).ready(function(){  
setTimeout(function(){
$('.shopify-payment-button__button').text('תשלום');
},2000);    
});

